import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  circularList: {
    height: "100vh",
    "& .MuiInputBase-root": {
      borderRadius: "40px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
    "& .MuiChip-root": {
      fontFamily: "inter",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        background: "#FEB62C",
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
  },
  // align: {
  //     marginLeft:"30px",
  // },
  backArrow: {
    cursor: "pointer",
    fontFamily: "inter !important",
    color: `${color.black}`,
    fontSize: "16px",
  },
  title: {
    fontFamily: "inter !important",
    color: `${color.darkGreen}`,
    fontSize: "18px",
    fontWeight: 700,
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  input_label: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    color: "#222222",
  },

  submit_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
}));
